import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "submit-loading-overlay"
}
const _hoisted_2 = {
  key: 1,
  xs12: ""
}
const _hoisted_3 = {
  key: 0,
  class: "timer-bar d-flex justify-center align-center py-2"
}
const _hoisted_4 = {
  key: 1,
  class: "embed-submit-footer"
}

import { ref, computed, watch, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { ROUTER_NAME } from '../../router'
import Exam from '../../models/exam'
import { checkMobile } from '../../utils/utils'
import ExamStatusForm from '../../../api/v2/forms/answer_status'
import { LETTER_FORMAT } from '../../utils/constants'
import QuestionGroupTestList from '../atoms_molecules/QuestionGroupTestList.vue'
import { headerState } from '../../stores/header'
import { differenceInSeconds } from 'date-fns'
import { footerState } from '../../stores/footer'
import { examTestState } from '../../stores/exam_test'
import { getQueryString } from '../../../../helpers/route-helper'
import ExamTimer from '../atoms_molecules/ExamTimer.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ExamTestQuestionList',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const { t } = useI18n()

const mobile = ref(checkMobile())
const time = ref(0)
const timeOut = ref(false)
const confirmDialog = ref(false)
const submitting = ref(false)
const isEmbed = computed(() => !!route.meta?.embed)

const exam = computed(() => examTestState.exam)
const redirectNotFoundPage = computed(() => examTestState.redirectNotFoundPage)
const groupExamTestQuestions = computed(() => examTestState.groupExamTestQuestions)
const answeredCount = computed(() => examTestState.examTestQuestionsAnswered.length)
const testQuestionCount = computed(() => examTestState.examTestIgnoreDescription.length)

const userExamId = computed(() => getQueryString(route.query, 'user_exam_id'))

const userExam = computed(() => {
  if (!userExamId.value) {
    return exam.value?.userExam
  }
  return exam.value?.userExams?.find(item => item.id == parseInt(userExamId.value as string))
})

const getQuestionNumber = (groupExamTestQuestion: any) => {
  return groupExamTestQuestions.value.filter(
    item => item.questions.every(question => !question.isDescriptionQuestion)
  ).indexOf(groupExamTestQuestion) + 1
}

const redirectToExamList = () => {
  router.push({ name: ROUTER_NAME.MY_EXAM_LIST })
}

const redirectToNotFoundPage = () => {
  router.push({ name: ROUTER_NAME.NOT_FOUND })
}

const updateData = (examData: Exam, routeData: any) => {
  if (examData && examData.isDone(userExam.value) && userExam.value?.isWaitingScoreCheck) {
    redirectToExamList()
    return
  }
  if (examData && examData.questions) {
    if (userExam.value?.finishedAt) {
      redirectToExamResult()
    }
  }
  if (mobile.value) {
    headerState.setTitle(t('question.answer_number', { format: LETTER_FORMAT.UPTITLECASE }) +
      ' ' +
      examData.answersFlowQuestion.length +
      '/' +
      examData.questionsIgnoreDescription.length)
    
    // Update timer
    time.value = examData.timeLimit * 60 - differenceInSeconds(new Date(), userExam.value?.startedAt)
    time.value = time.value > 0 ? time.value : 0
  }
}

const handleTimeUp = () => {
  timeOut.value = true
  showResult()
}

const redirectToExamResult = () => {
  router.push({
    name: ROUTER_NAME.EXAM_RESULT,
    params: { examId: route.params.examId as string },
    query: { user_exam_id: userExam.value?.id?.toString() }
  })
}

const backQuestion = () => {
  window.history.back()
}

const openConfirmDialog = () => {
  confirmDialog.value = true
}

const confirmSubmit = async () => {
  confirmDialog.value = false
  await showResult()
}

const showResult = async () => {
  if (submitting.value) return // prevent double submit
  submitting.value = true // show loading overlay + block interaction until navigation
  const examStatusForm = new ExamStatusForm()
  examStatusForm.examId = exam.value!.id
  examStatusForm.isFinishExam = true
  examStatusForm.userExamId = userExam.value?.id
  await examTestState.saveExamStatus({ examStatusForm })
  redirectToExamResult()
}

const last = () => {
  const qsId = exam.value!.userExam.questions[exam.value!.userExam.questions.length - 1].id
  router.push({
    name: ROUTER_NAME.QUESTION,
    params: {
      examId: route.params.examId as string,
      questionId: qsId.toString()
    },
    query: route.query
  })
}

const goQuestion = (questionId: number | string) => {
  const qId = typeof questionId === 'string' ? parseInt(questionId) : questionId
  if (qId != parseInt(route.params.questionId as string)) {
    router.push({
      name: ROUTER_NAME.QUESTION,
      params: {
        examId: `${exam.value!.id}`,
        questionId: `${qId}`
      },
      query: route.query
    })
  }
}

watch(exam, (val) => {
  if (val) {
    updateData(val, route)
  }
})

watch(() => route, () => {
  examTestState.requestExamTest(parseInt(route.params.examId as string)).then(() => {
    examTestState.setUserExamId(userExam.value?.id)
    examTestState.getExamTestQuestions()
  })
}, { immediate: true })

watch(redirectNotFoundPage, (val) => {
  if (val) {
    examTestState.setRedirectNotFoundPage({ status: false })
    redirectToNotFoundPage()
  }
})

onMounted(() => {
  if (mobile.value) {
    footerState.setFooter({
      color: '#f7931e',
      show: true,
      default: { show: false },
      buttons: {
        show: true,
        items: [
          { icon: 'mdi-chevron-double-left', round: false, color: 'white', action: backQuestion },
          { icon: 'mdi-chevron-left', round: false, color: 'white', action: last },
          { icon: '', round: true, color: 'white', label: t('common.submit', { format: LETTER_FORMAT.UPPERCASE }) as string, action: openConfirmDialog },
          { icon: 'mdi-chevron-right', round: false, color: 'white', disabled: true },
          { icon: 'mdi-chevron-double-right', round: false, color: 'white', disabled: true }
        ]
      }
    })
  } else {
    footerState.setFooterDefault()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_layout = _resolveComponent("v-layout")!

  return (_openBlock(), _createBlock(_component_v_layout, {
    "justify-content-center": "",
    wrap: "",
    class: "exam-final-screen"
  }, {
    default: _withCtx(() => [
      _createCommentVNode(" Submit loading overlay: spinner + block interaction until navigation "),
      (submitting.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              size: "56",
              width: "5",
              color: "#f7931e"
            })
          ]))
        : _createCommentVNode("v-if", true),
      (exam.value && !userExam.value.startedAt)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_v_alert, { type: "warning" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('question.warning_start_exam', { format: _unref(LETTER_FORMAT).UPTITLECASE })), 1 /* TEXT */)
              ]),
              _: 1 /* STABLE */
            })
          ]))
        : (exam.value && userExam.value.startedAt)
          ? (_openBlock(), _createElementBlock("div", {
              key: 2,
              xs12: "",
              class: _normalizeClass(['w-100', { 'pb-embed-footer': isEmbed.value && mobile.value }])
            }, [
              _createCommentVNode(" Timer for mobile "),
              (mobile.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(ExamTimer, {
                      time: time.value,
                      timeLimit: exam.value.timeLimit,
                      "start-time": userExam.value.startedAt.toISOString(),
                      onTimeUp: handleTimeUp
                    }, null, 8 /* PROPS */, ["time", "timeLimit", "start-time"])
                  ]))
                : _createCommentVNode("v-if", true),
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, { class: "exam-final-title" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('question.answer_rate', { format: _unref(LETTER_FORMAT).UPTITLECASE })) + " " + _toDisplayString(Math.round((answeredCount.value * 100) / testQuestionCount.value)) + "% (" + _toDisplayString(answeredCount.value + '/' + testQuestionCount.value) + ")", 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_divider, { class: "my-0" }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupExamTestQuestions.value, (groupExamTestQuestion, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: index + 'group'
                    }, [
                      _createVNode(QuestionGroupTestList, {
                        groupExamTestQuestion: groupExamTestQuestion,
                        questionNumber: getQuestionNumber(groupExamTestQuestion),
                        padding: true,
                        onClick: goQuestion
                      }, null, 8 /* PROPS */, ["groupExamTestQuestion", "questionNumber"]),
                      (index + 1 < groupExamTestQuestions.value.length)
                        ? (_openBlock(), _createBlock(_component_v_divider, {
                            key: index + 'group_divider',
                            class: "my-0"
                          }))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }),
              _createCommentVNode(" Confirm Dialog "),
              _createVNode(_component_v_dialog, {
                modelValue: confirmDialog.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((confirmDialog).value = $event)),
                width: "500"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card_title, { class: "headline bg-grey-lighten-2" }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createTextVNode(" 本当に提出してよろしいですか？ ", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_v_card_actions, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            variant: "text",
                            onClick: confirmSubmit
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('common.submit', { format: _unref(LETTER_FORMAT).UPTITLECASE })), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue"]),
              _createCommentVNode(" Submit footer for embed mode (embed app has no Footer component) "),
              (isEmbed.value && mobile.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_v_btn, {
                      icon: true,
                      rounded: "",
                      class: "m-1 nav-btn",
                      onClick: backQuestion
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createTextVNode("mdi-chevron-double-left", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_btn, {
                      icon: true,
                      rounded: "",
                      class: "m-1 nav-btn",
                      onClick: last
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                            _createTextVNode("mdi-chevron-left", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_btn, {
                      rounded: "",
                      class: "m-1 submit-btn",
                      onClick: openConfirmDialog
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.submit', { format: _unref(LETTER_FORMAT).UPTITLECASE })), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_btn, {
                      icon: true,
                      rounded: "",
                      class: "m-1 nav-btn",
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createTextVNode("mdi-chevron-right", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_btn, {
                      icon: true,
                      rounded: "",
                      class: "m-1 nav-btn",
                      disabled: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode("mdi-chevron-double-right", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        })
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}
}

})